import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TableModule} from "primeng/table";
import {ButtonModule} from "primeng/button";
import {ApiComponent} from "./api.component";
import {BadgeComponent} from "./badge.component";
import {TextComponent} from "./text.component";
import {FormsModule} from "@angular/forms";
import {InputTextareaModule} from "primeng/inputtextarea";
import {InputTextModule} from "primeng/inputtext";
import {FileUploadModule} from "primeng/fileupload";
import {DialogModule} from "primeng/dialog";
import {ChartModule} from "primeng/chart";
import {InputNumberModule} from "primeng/inputnumber";
import {MessageModule} from "primeng/message";
import {ProgressBarModule} from "primeng/progressbar";
import {DropdownModule} from "primeng/dropdown";
import {ClipboardModule, ClipboardService} from "ngx-clipboard";
import {classifierRoutes} from "./classifier.routing";
import {HttpClientModule} from "@angular/common/http";
import {ClassifierService} from "../../service/classifier.service";
import {HowtoComponent} from "./howto.component";
import {ToastModule} from "primeng/toast";
import {CommonsModule} from "../commons.module";

@NgModule({
  imports: [CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    InputTextareaModule,
    InputTextModule,
    FileUploadModule,
    ToastModule,
    DialogModule,
    ChartModule,
    InputNumberModule,
    MessageModule,
    ProgressBarModule,
    DropdownModule,
    ClipboardModule,
    CommonsModule,
    classifierRoutes],
  declarations: [ApiComponent, BadgeComponent, TextComponent, HowtoComponent],
  exports: [],
  providers: [ClassifierService, HttpClientModule, ClipboardService]
})
export class ClassifierModule {
}
